import React from "react";
import JobPost from "../../components/careerPage/JobPost";

const Career = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Intro */}
      <header
        className="header-page header-fullscreen header-page--gutterBottom jarallaxVideo reveal"
        style={{ color: "white" }}
        data-jarallax-video="mp4:https://res.cloudinary.com/dopcyrucs/video/upload/v1672487906/video/Career_mdwixt.mp4"
      >
        <div
          style={{
            height: "100vh",
            width: "100%",
            position: "absolute",
            background: "#000000cc",
          }}
        />
        <div className="container flex-center-end js-opacity">
          {/* Title */}
          <div className="flex-center">
            <div className="flex-center__inner">
              <div className="container">
                {/* Title */}
                {/* <h6 class="title title--overhead title--tail">Career</h6> */}
                <h1 className="title title--display-1 js-lines">
                  Given a seat means growth. It also means great responsibility.
                  Is it yours?
                </h1>
                {/* /Title */}
              </div>
            </div>
          </div>
          {/* /Title */}
        </div>
      </header>
      {/* /Intro */}
      {/* Process */}
      <article id="start" className="caption-singles container">
        <div className="row">
          {/* Intro */}
          <header className="header-page  js-opacity">
            <div className="container">
              {/* Title */}
              <h6 className="title title--overhead title--tail">Career</h6>
              <h1 className="title title--display-1 js-lines">
                Come work with us.
              </h1>
              {/* /Title */}
            </div>
          </header>
          {/* /Intro */}
          <div className="col-12 col-lg-9 m-l">
            <div className="description noGutters-Bottom js-block">
              <p className="paragraph noGutters-Bottom">
                Basic Skill, Ability To Work Hard, Determination And Honesty
                Towards The Craft Are The Four Simple Things To Excel At Work.
                You Know The Rest Of It (Which Is Quite A Lot) Just Happen To
                Fall In Place. Some Things Are Cliched But It's True.
              </p>
            </div>
          </div>
        </div>
      </article>
      {/* /Process */}

      {/*  jobpost card  */}

      <div className="container main-c">
        <JobPost />
      </div>
      <div className="col-12 col-md-12 footer__left">
        <div className="c-r">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 section__header-wrap">
              <h2
                className="title title__h2 title_center title_normal js-block"
                style={{ fontWeight: 100 }}
              >
                <span className="">
                  Don't see a job opening for yourself here? We suggest let's
                  stay in touch because we might need you in a couple of months.
                  Send your resume to{" "}
                  <strong style={{ color: "#56b7be !important" }}>
                    <a href="mailto:career@dmtca.com ">career@dmtca.com</a>
                  </strong>
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      {/* Team */}

      {/* Contact Form */}
      <div className="popup popup-overlay">
        <button
          id="close-popup"
          className="popup__btn-close"
          aria-label="Close"
        >
          close
        </button>
        <div className="popup-inner">
          {/* Form */}
          <h2 className="title title--h3 text-lg-center js-lines" style={{}}>
            <div
              style={{
                display: "block",
                textAlign: "center",
                position: "relative",
                opacity: 1,
                transform: "matrix(1, 0, 0, 1, 0, 0)",
              }}
            >
              Submit your resume
            </div>
          </h2>
          <form
            id="contact-form"
            className="contact-form"
            data-toggle="validator"
            noValidate="true"
            encType="�multipart/form-data�"
          >
            <div className="container container_md">
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="inputText"
                      id="frmname"
                      name="frmname"
                      placeholder="Full Name"
                      required="required"
                    />
                    {/*<div class="help-block with-errors"></div> */}
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="form-group">
                    <input
                      type="email"
                      className="inputText"
                      id="frmemail"
                      name="frmemail"
                      placeholder="Email Address"
                      required="required"
                      autoComplete="off"
                      oninvalid="setCustomValidity('Email is incorrect')"
                      onkeyup="setCustomValidity('')"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="inputText"
                      id="frmphone"
                      name="frmphone"
                      placeholder="Phone Number"
                      required="required"
                      autoComplete="off"
                      oninvalid="setCustomValidity('Fill in the field')"
                      onkeyup="setCustomValidity('')"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="inputText"
                      id="frmrole"
                      name="frmrole"
                      placeholder="Job Role
			"
                      required="required"
                      autoComplete="off"
                      oninvalid="setCustomValidity('Fill in the field')"
                      onkeyup="setCustomValidity('')"
                    />
                    <div className="help-block with-errors" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <div className="form-group">
                    <input type="file" name="attachment" />
                  </div>
                </div>
              </div>
              {/*	<div class="col-12 col-lg-6">
									<div class="form-group">
											<input type="text" pattern="((www.)?)(([^.]+)\.)?([a-zA-z0-9\-_]+)(.com|.net|.gov|.org|.in)(\/[^\s]*)?" class="inputText" id="frmwebsite" name="frmwebsite"
												placeholder="Company Website" required="required" autocomplete="off"
												oninvalid="setCustomValidity('Website url not valid. ')" onkeyup="setCustomValidity('')">
											<div class="help-block with-errors"></div>
										</div>
									</div>
								</div>*/}
              {/*	<div class="row">
									<div class="col-12 col-lg-12">
										<div class="form-group">
											<input type="text" class="inputText" id="frmmessage" name="frmmessage"
												placeholder="Your Message" required="required"
												autocomplete="off" oninvalid="setCustomValidity('Fill in the field')"
												onkeyup="setCustomValidity('')">
											<div class="help-block with-errors"></div>
										</div>
									</div>
								</div>
								<!-- <div class="row">
							        <div class="col-12 col-lg-12">
									    <div class="form-group">
			                                <textarea class="textarea" id="message" name="message" placeholder="Message" rows="1" required="required" oninvalid="setCustomValidity('Fill in the field')" onkeyup="setCustomValidity('')" style="overflow: hidden; overflow-wrap: break-word; height: 54px;"></textarea>
											<div class="help-block with-errors"></div>
										</div>
							        </div>
						        </div> */}
              <div className="row align-items-center">
                <div
                  className="col-12 col-md-12"
                  style={{ textAlign: "center" }}
                >
                  <button type="submit" className="btn2 disabled">
                    Submit Resume
                  </button>
                </div>
                <div className="col-12 col-md-12 text-md-right">
                  <div id="validator-contact" className="_hidden">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </form>
          {/* /Form */}
        </div>
      </div>
      {/* /Contact Form */}
    </>
  );
};

export default Career;
